import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Star, Award, Clock, Shield, MapPin, Phone, Mail, Building2, 
  Users, Wrench, Zap, Thermometer, Wind, Factory,
  Hospital, GraduationCap, Droplets, UtensilsCrossed, Home,
  HardHat, Menu, X, ChevronRight, Trophy
} from 'lucide-react';
import Lightbox from '../components/Lightbox';

// Logo URL - User provided
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/l2ttubxj_Logo%20Magna%20specialty%20contractors.png';

// Leadership photos - User provided
const GREGORIO_IMG = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/s4st0zab_Gregorio%20Burciaga.png';
const YADIRA_IMG = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/arlgsag4_Yadira%20Burciaga.png';

// Certification logos - User provided
const CERT_WBENC = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/lvhgsyjj_certified%20wbenc.png';
const CERT_HCA = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/sa0spjje_hispanic%20contractors%20association%20texas.png';
const CERT_MWBE = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/pyin93cd_minority%20and%20women%20owned%20business%20enterprises.png';
const CERT_MBE = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/u8eping1_minority%20owned%20mbe%20certification%20businesses%20enterprise.png';
const CERT_NCTRCA = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/o8quij1u_north%20central%20regional%20certification%20agency.png';
const CERT_SBE = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/in9e4xlq_small%20business%20sbe%20certified%20enterprise.png';
const RHCA_AWARD = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/fpuk4gwt_Pillar%20Award%202018%20RHCA%20Regional%20Hispanic%20Contractors%20association.png';

// Hero background images - User provided (carousel)
const HERO_IMAGES = [
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/8ezowoq4_HOME.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/0b019nkk_HOME%20%282%29.png'
];

// Project images - User provided
const PROJECT_DISD = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/3jz1lyf5_DISD%20UTSW%20Bio-Medical.png';
const PROJECT_HCA = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/0fmlkgxk_HCA%20Behavioral%20Health.png';
const PROJECT_CARTER = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/v1zw01bm_Carter%20MS.png';
const PROJECT_SHERMAN = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/fdl89ad8_Sherman%20WTP.png';
const PROJECT_METROCARE = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/tf0sxo89_Metrocare%20Client%20Services%20%26%20Clinic.png';
const PROJECT_PRINCETON = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/w3wb8ub4_Princeton%20Tom%20Banschbach%20MS.png';
const PROJECT_PARADISE = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/ka1xjcb9_New%20Paradise%20HS.png';
const PROJECT_HIGHLANDS = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/dfxns2e0_Highlands%20Springs%20Ericson.png';
const PROJECT_USPI = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/lzoxkw56_USPI%20Weatheford.png';
const PROJECT_CROWLEY_HS = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/esgnsbz8_Crowley%20HS%20Indoor%20Track%20%26%20Field.png';
const PROJECT_CROWLEY_ACADEMY = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/vz9e85fc_Crowley%20Colligiate.png';
const PROJECT_BURLESON = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/mzss9j8n_Burlesen%20Police.png';
const PROJECT_AUTOBAHN = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/qqzfmcpe_Autobahn%20Fort%20Worth%20%28various%20dealerships%29.png';
const PROJECT_WILLOW = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/2tgvzh6y_Willlow%20Park%20Hospital.png';
const PROJECT_DFW = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/2c79mbzn_DFW%20Airport%20-%20CTAE%20Pier%20TAC.png';
const PROJECT_RIVERSIDE = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/luuln20l_FWISD%20Riverside%20MS.png';
const PROJECT_FOREST = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/r51a80tx_FWISD%20Forest%20Oak.png';
const PROJECT_EASTERN = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/p2msg75o_FWISD%20Eastern%20Hills.png';
const PROJECT_PLANO = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/zhkbg90l_Plano%20ISD%20Williams%20MS.png';

// Service images - User provided
const SERVICE_MECHANICAL = [
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/wu89kcv7_Mechanical%20Insulation.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/5zv8z0s0_Mechanical%20Insulation.png'
];
const SERVICE_HVAC = [
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/yzr7svfz_HVAC%20%26%20Ductwork%20Insulation.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/bnfopgwo_HVAC%20%26%20Ductwork%20Insulation%20%282%29.png'
];
const SERVICE_HEAT_TRACE = [
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/2ksfmvhk_Heat%20Trace%20Systems.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/28g6cvyg_Heat%20Trace%20Systems%20%282%29.png'
];
const SERVICE_PLUMBING = [
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/jm7pzvrh_Plumbing%20Insulation.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/nhlc5yba_Plumbing%20Insulation%20%282%29.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/ds7ukxu1_Plumbing%20Insulation.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/g49f9ghr_Plumbing%20Insulation%20%282%29.png'
];
const SERVICE_EXHAUST = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/b6566bfe_Exhaust%20%26%20Specialty%20Systems.png';
const SERVICE_INDUSTRIAL = [
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/xy1t04h4_Industrial%20Systems.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/rssgwll0_Industrial%20Systems.png',
  'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/t2hzw3mw_Industrial%20Systems%20%282%29.png'
];

// Team photos - User provided
const LADYS_TEAM_IMG = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/m9x99zbv_Ladys%20Original.png';
const BOYS_TEAM_IMG = 'https://customer-assets.emergentagent.com/job_insulation-experts/artifacts/p3l623a2_Boys%20Original.png';

const HomePage = () => {
  const [lightbox, setLightbox] = useState({ isOpen: false, imageSrc: '', imageAlt: '' });
  const [formStatus, setFormStatus] = useState({ submitting: false, message: '', type: '' });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openLightbox = (imageSrc, imageAlt) => {
    setLightbox({ isOpen: true, imageSrc, imageAlt });
  };

  const closeLightbox = () => {
    setLightbox({ isOpen: false, imageSrc: '', imageAlt: '' });
  };

  // State for service image carousels
  const [serviceImageIndex, setServiceImageIndex] = useState({});

  const toggleServiceImage = (serviceTitle, totalImages) => {
    setServiceImageIndex(prev => ({
      ...prev,
      [serviceTitle]: ((prev[serviceTitle] || 0) + 1) % totalImages
    }));
  };

  const getServiceImage = (service) => {
    if (Array.isArray(service.images)) {
      const index = serviceImageIndex[service.title] || 0;
      return service.images[index];
    }
    return service.image;
  };

  // Hero image carousel
  const [heroImageIndex, setHeroImageIndex] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setHeroImageIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, message: '', type: '' });

    // Placeholder for Formspree - user will configure later
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    // Simulate form submission (replace with actual Formspree endpoint)
    try {
      // When Formspree is configured, replace this URL
      const response = await fetch('https://formspree.io/f/YOUR_FORM_ID', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        setFormStatus({ 
          submitting: false, 
          message: 'Thank you for your quote request. We will contact you within 48 hours.', 
          type: 'success' 
        });
        e.target.reset();
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setFormStatus({ 
        submitting: false, 
        message: 'Form submission is not configured yet. Please call us directly at (682) 320-8668.', 
        type: 'info' 
      });
    }
  };

  const services = [
    {
      title: 'Mechanical Insulation',
      description: 'Complete insulation systems for commercial and industrial piping, HVAC equipment, and mechanical systems of any scale.',
      bullets: ['Chilled & heating water systems', 'Domestic hot/cold & potable water', 'Glycol & steam/condensate lines', 'Chillers, tanks, pumps & equipment'],
      images: SERVICE_MECHANICAL,
      icon: Wrench
    },
    {
      title: 'HVAC & Ductwork Insulation',
      description: 'Precision insulation for all HVAC ductwork systems, ensuring optimal thermal performance and energy efficiency.',
      bullets: ['Supply & return air ducts', 'Outside air & energy recovery units', 'Refrigerant lines', 'Exhaust & ventilation systems'],
      images: SERVICE_HVAC,
      icon: Wind
    },
    {
      title: 'Heat Trace Systems',
      description: 'Certified design and installation of electric heat trace systems protecting pipes from freezing and maintaining process temperatures.',
      bullets: ['Freeze protection systems', 'Process temperature maintenance', 'Self-regulating & constant wattage', 'Controls & monitoring systems'],
      images: SERVICE_HEAT_TRACE,
      icon: Thermometer
    },
    {
      title: 'Plumbing Insulation',
      description: 'Specialized insulation for plumbing systems, including sanitary, storm drain, and grease waste piping.',
      bullets: ['Sanitary & storm drain piping', 'Grease waste systems', 'Non-potable water lines'],
      images: SERVICE_PLUMBING,
      icon: Droplets
    },
    {
      title: 'Exhaust & Specialty Systems',
      description: 'Expert insulation for high-temperature exhaust systems, boiler breachings, and specialty industrial applications.',
      bullets: ['Kitchen exhaust (grease ducts)', 'Generator & boiler exhaust', 'Flues & breachings', 'High-temperature applications'],
      image: SERVICE_EXHAUST,
      icon: Zap
    },
    {
      title: 'Industrial Systems',
      description: 'Large-scale industrial insulation for process piping, wastewater facilities, food processing plants, and demanding environments.',
      bullets: ['Process piping & equipment', 'Wastewater treatment systems', 'Food processing facilities', 'Custom industrial solutions'],
      images: SERVICE_INDUSTRIAL,
      icon: Factory
    }
  ];

  const industries = [
    { 
      icon: Hospital, 
      name: 'Healthcare & Hospitals', 
      description: 'Critical insulation for healthcare facilities, medical office buildings, and hospitals where performance and compliance are non-negotiable.',
      tags: 'MOBS · HOSPITALS'
    },
    { 
      icon: GraduationCap, 
      name: 'Education & Universities', 
      description: 'Complete mechanical insulation for educational campuses, K-12 schools, and university facilities across North Texas.',
      tags: 'K-12 · UNIVERSITIES'
    },
    { 
      icon: Factory, 
      name: 'Industrial & Wastewater', 
      description: 'Heavy-duty insulation for industrial plants, food processing facilities, and wastewater treatment operations.',
      tags: 'INDUSTRIAL · WASTEWATER'
    },
    { 
      icon: Building2, 
      name: 'Commercial & Retail', 
      description: 'Insulation for retail centers, restaurants, and commercial office buildings requiring energy-efficient mechanical systems.',
      tags: 'RETAIL · RESTAURANTS'
    },
    { 
      icon: Shield, 
      name: 'Religious & Public Safety', 
      description: 'Dedicated insulation for religious facilities, fire stations, and public safety buildings throughout DFW.',
      tags: 'CHURCHES · FIRE STATIONS'
    },
    { 
      icon: Home, 
      name: 'Multi-Family & Mixed-Use', 
      description: 'Multi-family housing, apartment complexes, and mixed-use developments demanding consistent quality at scale.',
      tags: 'MULTI-FAMILY · MIXED USE'
    },
    { 
      icon: UtensilsCrossed, 
      name: 'Food Processing', 
      description: 'Specialized insulation where thermal control, hygiene compliance, and operational continuity are critical.',
      tags: 'FOOD PROCESSING'
    },
    { 
      icon: HardHat, 
      name: 'New Construction', 
      description: 'Ground-up insulation packages coordinated with mechanical and plumbing contractors from early project phases.',
      tags: 'NEW BUILD · GC PARTNERS'
    },
    { 
      icon: Wrench, 
      name: 'Retrofit & Renovation', 
      description: 'Existing building upgrades requiring re-insulation of mechanical systems with minimal disruption.',
      tags: 'RETROFIT · RENOVATION'
    }
  ];

  const projects = [
    {
      category: 'New Construction Recently Completed',
      items: [
        { name: 'DISD UTSW Biomedical', industry: 'Education K-12', image: PROJECT_DISD },
        { name: 'HCA Behavioral Health', industry: 'Medical', image: PROJECT_HCA },
        { name: 'Carter JHS Replacement', industry: 'Education K-12', image: PROJECT_CARTER },
        { name: 'Sherman WTP', industry: 'Industrial', image: PROJECT_SHERMAN },
        { name: 'Metrocare', industry: 'Medical/Office', image: PROJECT_METROCARE },
        { name: 'Princeton Tom Banschbach MS', industry: 'Education K-12', image: PROJECT_PRINCETON }
      ]
    },
    {
      category: 'New Construction On Going',
      items: [
        { name: 'New Paradise HS', industry: 'Education K-12', image: PROJECT_PARADISE },
        { name: 'Highlands Springs Ericson', industry: 'Multifamily', image: PROJECT_HIGHLANDS },
        { name: 'USPI ASC Weatherford', industry: 'Medical', image: PROJECT_USPI },
        { name: 'Crowley HS Indoor Field & Athletics', industry: 'Education K-12', image: PROJECT_CROWLEY_HS },
        { name: 'Crowley Collegiate Academy', industry: 'Education K-12', image: PROJECT_CROWLEY_ACADEMY },
        { name: 'Burleson Police', industry: 'Law Enforcement', image: PROJECT_BURLESON },
        { name: 'Autobahn Fort Worth', industry: 'Various Dealerships', image: PROJECT_AUTOBAHN },
        { name: 'Willow Park Hospital', industry: 'Medical', image: PROJECT_WILLOW }
      ]
    },
    {
      category: 'Remodels On Going',
      items: [
        { name: 'DFW Airport - CTAE Pier TAC', industry: 'Airport', image: PROJECT_DFW },
        { name: 'FWISD Riverside MS', industry: 'Education K-12', image: PROJECT_RIVERSIDE },
        { name: 'FWISD Forest Oak', industry: 'Education K-12', image: PROJECT_FOREST },
        { name: 'FWISD Eastern Hills', industry: 'Education K-12', image: PROJECT_EASTERN },
        { name: 'Plano ISD Williams MS', industry: 'Education K-12', image: PROJECT_PLANO }
      ]
    }
  ];

  const certifications = [
    { name: 'SBE Certified', number: 'HFSB64232N0821' },
    { name: 'MBE Certified', number: 'FHMB74407N0821' },
    { name: 'WBE Certified', number: 'HFWB51778N0821' }
  ];

  const navLinks = [
    { label: 'Home', id: 'home' },
    { label: 'Services', id: 'services' },
    { label: 'Industries', id: 'industries' },
    { label: 'Projects', id: 'projects' },
    { label: 'Certifications', id: 'certifications' },
    { label: 'About Us', id: 'about' }
  ];

  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      {/* Sticky Header Container - Top Bar + Navbar */}
      <div className="sticky top-0 z-50">
        {/* Top Bar */}
        <div className="bg-[#53131e] text-white py-2" data-testid="top-bar">
          <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-2">
            <Star className="w-4 h-4 fill-white text-white" strokeWidth={1.5} />
            <span className="text-sm tracking-wide font-bold">Women and Minority-Owned Certified Business</span>
            <Star className="w-4 h-4 fill-white text-white" strokeWidth={1.5} />
          </div>
        </div>

        {/* Navbar */}
        <nav className="bg-[#53131e] text-white" data-testid="navbar">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo & Company Name */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')} data-testid="navbar-logo">
              <img 
                src={LOGO_URL} 
                alt="Magna Specialty Contractors Corp. Logo"
                className="h-16 w-auto"
              />
              <div className="hidden sm:flex flex-col leading-tight">
                <span className="font-semibold text-white tracking-wide text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>MAGNA SPECIALTY</span>
                <span className="font-semibold text-white tracking-wide text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>CONTRACTORS CORP.</span>
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <button 
                  key={link.id}
                  onClick={() => scrollToSection(link.id)} 
                  className="text-white hover:text-gray-200 transition-colors text-lg font-medium"
                  data-testid={`nav-link-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
            </div>

            {/* CTA Button & Mobile Menu */}
            <div className="flex items-center gap-4">
              <button 
                onClick={() => scrollToSection('contact')}
                className="hidden sm:block bg-white text-[#53131e] px-6 py-2.5 rounded-sm font-semibold text-lg hover:bg-gray-100 transition-colors"
                data-testid="navbar-cta-button"
              >
                Contact Us
              </button>
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden p-2 text-white"
                aria-label="Toggle menu"
                data-testid="mobile-menu-toggle"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-[#53131e] border-t border-white/20 py-4" data-testid="mobile-menu">
            <div className="max-w-7xl mx-auto px-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <button 
                  key={link.id}
                  onClick={() => scrollToSection(link.id)} 
                  className="text-white hover:text-gray-200 transition-colors text-left py-2 font-medium"
                  data-testid={`mobile-nav-link-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-white text-[#53131e] px-6 py-3 rounded-sm font-semibold text-lg hover:bg-gray-100 transition-colors mt-2"
                data-testid="mobile-cta-button"
              >
                Contact Us
              </button>
            </div>
          </div>
        )}
        </nav>
      </div>

      {/* Hero Section */}
      <section id="home" className="relative min-h-[90vh] flex items-center justify-center" data-testid="hero-section">
        <div className="absolute inset-0 z-0">
          <AnimatePresence mode="wait">
            <motion.img
              key={heroImageIndex}
              src={HERO_IMAGES[heroImageIndex]}
              alt="Professional industrial construction site"
              className="w-full h-full object-cover absolute inset-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
            />
          </AnimatePresence>
          <div className="absolute inset-0 bg-black/15"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 text-center text-white">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-6"
            style={{ textShadow: '0 2px 12px rgba(0,0,0,0.7), 0 0 40px rgba(0,0,0,0.4)' }}
            data-testid="hero-headline"
          >
            Mechanical Insulation &<br />Heat Trace Specialists
          </motion.h1>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="flex items-center justify-center text-xl md:text-2xl mb-10"
            style={{ fontFamily: "'Manrope', sans-serif", textShadow: '0 2px 10px rgba(0,0,0,0.7), 0 0 30px rgba(0,0,0,0.3)' }}
          >
            <MapPin className="w-5 h-5 mr-2" strokeWidth={1.5} />
            <span>North Texas · Commercial & Industrial</span>
          </motion.div>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center mb-16"
          >
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-[#53131e] text-white px-8 py-4 rounded-sm font-semibold text-lg hover:bg-[#3d0e16] transition-colors flex items-center justify-center gap-2"
              data-testid="hero-cta-button"
            >
              Contact Us
              <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-sm font-semibold text-lg hover:bg-white/20 transition-colors border border-white/30"
              data-testid="hero-services-button"
            >
              Our Services
            </button>
          </motion.div>

          {/* Stats Bar */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.45 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto"
            data-testid="hero-stats"
          >
            <div className="flex flex-col items-center">
              <Award className="w-10 h-10 mb-3" strokeWidth={1.5} />
              <p className="text-xl font-semibold">30+ Years Experience</p>
            </div>
            <div className="flex flex-col items-center">
              <Clock className="w-10 h-10 mb-3" strokeWidth={1.5} />
              <p className="text-xl font-semibold">48-Hour Response</p>
            </div>
            <div className="flex flex-col items-center">
              <Shield className="w-10 h-10 mb-3" strokeWidth={1.5} />
              <p className="text-xl font-semibold">1-Year Warranty</p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Trust Bar */}
      <section className="bg-[#0a0a0a] text-white py-10" data-testid="trust-bar">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="text-3xl md:text-4xl font-bold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>1,000+</p>
              <p className="text-gray-400 text-sm">Projects Completed</p>
            </div>
            <div>
              <p className="text-3xl md:text-4xl font-bold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>30+</p>
              <p className="text-gray-400 text-sm">Skilled Employees</p>
            </div>
            <div>
              <a href="tel:6823208668" className="block group" data-testid="trust-phone-link">
                <Phone className="w-6 h-6 mx-auto mb-2 text-white" strokeWidth={1.5} />
                <p className="text-lg font-semibold group-hover:text-[#53131e] transition-colors">(682) 320-8668</p>
              </a>
            </div>
            <div>
              <a href="mailto:magnabids@magnaspecialtycontractors.net" className="block group" data-testid="trust-email-link">
                <Mail className="w-6 h-6 mx-auto mb-2 text-white" strokeWidth={1.5} />
                <p className="text-sm font-semibold group-hover:text-[#53131e] transition-colors whitespace-nowrap">magnabids@magnaspecialtycontractors.net</p>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 md:py-24 bg-white" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center mb-16" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="border border-[#cccccc] overflow-hidden"
                data-testid={`service-card-${index}`}
              >
                <div 
                  className="relative h-56 cursor-pointer image-hover-overlay"
                  onClick={() => {
                    if (service.images) {
                      toggleServiceImage(service.title, service.images.length);
                    } else {
                      openLightbox(service.image, service.title);
                    }
                  }}
                  data-testid={`service-image-${index}`}
                >
                  <img 
                    src={getServiceImage(service)} 
                    alt={service.title}
                    className="w-full h-full object-cover transition-opacity duration-300"
                  />
                  {service.images && (
                    <div className="absolute bottom-3 right-3 flex gap-1.5">
                      {service.images.map((_, imgIdx) => (
                        <div 
                          key={imgIdx}
                          className={`w-2.5 h-2.5 rounded-full transition-colors ${
                            (serviceImageIndex[service.title] || 0) === imgIdx 
                              ? 'bg-[#53131e]' 
                              : 'bg-white/60'
                          }`}
                        />
                      ))}
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <service.icon className="w-6 h-6 text-[#53131e]" strokeWidth={1.5} />
                    <h3 className="text-xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{service.title}</h3>
                  </div>
                  <p className="text-gray-600 text-[15px] leading-relaxed mb-4">{service.description}</p>
                  {service.bullets && (
                    <ul className="text-gray-500 text-sm space-y-1">
                      {service.bullets.map((bullet, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <span className="text-[#53131e] mt-1">•</span>
                          <span>{bullet}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section id="industries" className="py-20 md:py-24 bg-[#0a0a0a] text-white" data-testid="industries-section">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center mb-16" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Industries We Serve</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-l border-t border-white/20">
            {industries.map((industry, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                viewport={{ once: true }}
                className="border-r border-b border-white/20 p-8 text-left"
                data-testid={`industry-card-${index}`}
              >
                <industry.icon className="w-12 h-12 mb-6 text-white" strokeWidth={1.5} />
                <h4 className="text-2xl mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{industry.name}</h4>
                <p className="text-gray-400 text-[15px] leading-relaxed mb-6">{industry.description}</p>
                <p className="text-xs uppercase tracking-widest text-gray-500">{industry.tags}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="py-20 md:py-24 bg-white" data-testid="projects-section">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center mb-16" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Notable Projects</h2>
          {projects.map((category, catIndex) => (
            <div key={catIndex} className="mb-16 last:mb-0">
              <h3 className="text-2xl mb-8 text-[#53131e]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{category.category}</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {category.items.map((project, index) => (
                  <motion.div 
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.05 }}
                    viewport={{ once: true }}
                    className="border border-[#cccccc] overflow-hidden"
                    data-testid={`project-card-${catIndex}-${index}`}
                  >
                    {project.image ? (
                      <div 
                        className="relative h-44 cursor-pointer image-hover-overlay"
                        onClick={() => openLightbox(project.image, project.name)}
                        data-testid={`project-lightbox-trigger-${catIndex}-${index}`}
                      >
                        <img 
                          src={project.image} 
                          alt={project.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <div className="relative h-44 bg-gray-100 flex items-center justify-center">
                        <div className="text-center text-gray-400">
                          <Building2 className="w-12 h-12 mx-auto mb-2" strokeWidth={1} />
                          <p className="text-xs">Image Coming Soon</p>
                        </div>
                      </div>
                    )}
                    <div className="p-4">
                      <h4 className="text-base font-semibold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{project.name}</h4>
                      <p className="text-[#53131e] text-sm">{project.industry}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Certifications & Awards Section */}
      <section id="certifications" className="py-20 md:py-24 bg-[#f5f5f5]" data-testid="certifications-section">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center mb-16" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Certifications & Awards</h2>
          
          {/* Certification Numbers - Large Display */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {certifications.map((cert, index) => (
              <div key={index} className="text-center" data-testid={`certification-${index}`}>
                <p className="text-4xl md:text-5xl font-bold text-[#53131e] mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {cert.name.split(' ')[0]}
                </p>
                <p className="text-sm uppercase tracking-widest text-gray-500 mb-2">{cert.name}</p>
                <p className="text-lg font-mono text-[#0a0a0a]">{cert.number}</p>
              </div>
            ))}
          </div>

          {/* Additional Certifications - Logo Images */}
          <div className="mb-16">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center justify-items-center">
              <div className="bg-white p-4 w-full flex items-center justify-center">
                <img src={CERT_WBENC} alt="WBENC Certified" className="h-20 w-auto object-contain" />
              </div>
              <div className="bg-white p-4 w-full flex items-center justify-center">
                <img src={CERT_MBE} alt="MBE Certified" className="h-20 w-auto object-contain" />
              </div>
              <div className="bg-white p-4 w-full flex items-center justify-center">
                <img src={CERT_MWBE} alt="MWBE Certified" className="h-20 w-auto object-contain" />
              </div>
              <div className="bg-white p-4 w-full flex items-center justify-center">
                <img src={CERT_HCA} alt="Hispanic Contractors Association de Tejas" className="h-20 w-auto object-contain" />
              </div>
              <div className="bg-white p-4 w-full flex items-center justify-center">
                <img src={CERT_NCTRCA} alt="NCTRCA - North Central Texas Regional Certification Agency" className="h-20 w-auto object-contain" />
              </div>
              <div className="bg-white p-4 w-full flex items-center justify-center">
                <img src={CERT_SBE} alt="SBE - Small Business Enterprise Certified" className="h-20 w-auto object-contain" />
              </div>
            </div>
          </div>

          {/* RHCA Pillar Award */}
          <div className="text-center" data-testid="award-display">
            <div className="inline-block bg-white border border-[#cccccc] p-6 max-w-md">
              <img 
                src={RHCA_AWARD} 
                alt="RHCA Pillar Award 2018 - Subcontractor of the Year Class I - Magna Specialty Contractors Corp."
                className="w-full h-auto object-contain cursor-pointer"
                onClick={() => openLightbox(RHCA_AWARD, 'RHCA Pillar Award 2018')}
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="py-20 md:py-24 bg-white" data-testid="about-section">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center mb-16" style={{ fontFamily: "'Cormorant Garamond', serif" }}>About Us</h2>
          
          <div className="max-w-3xl mx-auto mb-16">
            {/* Mission & Vision */}
            <div className="text-center">
              <h3 className="text-3xl mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Our Mission & Vision</h3>
              <p className="text-[17px] text-gray-700 mb-6 leading-relaxed">
                At Magna Specialty Contractors Corp., we are committed to delivering exceptional mechanical insulation and heat trace solutions across North Texas. As a women and minority-owned certified business, we bring over 30 years of expertise to every project.
              </p>
              <p className="text-[17px] text-gray-700 mb-6 leading-relaxed">
                Our vision is to be the premier specialty contractor in the DFW Metroplex, known for our technical excellence, rapid response times, and unwavering commitment to quality workmanship.
              </p>
              <p className="text-[17px] text-gray-700 leading-relaxed">
                With a team of 30+ skilled professionals and a track record of over 1,000 completed projects, we stand behind every installation with our 1-year workmanship warranty and 48-hour response guarantee.
              </p>
            </div>
          </div>

          {/* Leadership */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              viewport={{ once: true }}
              className="border border-[#cccccc] overflow-hidden"
              data-testid="leader-card-1"
            >
              <div 
                className="aspect-[3/4] cursor-pointer image-hover-overlay bg-gray-100"
                onClick={() => openLightbox(YADIRA_IMG, 'Yadira Burciaga - President & CFO')}
              >
                <img 
                  src={YADIRA_IMG} 
                  alt="Yadira Burciaga - President & CFO"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h4 className="text-2xl mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Yadira Burciaga</h4>
                <p className="text-[#53131e] font-semibold text-sm mb-3">President & CFO</p>
                <p className="text-gray-600 text-[15px] leading-relaxed">Leading Magna Specialty Contractors with strategic vision and financial expertise, ensuring operational excellence and sustainable growth.</p>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              viewport={{ once: true }}
              className="border border-[#cccccc] overflow-hidden"
              data-testid="leader-card-2"
            >
              <div 
                className="aspect-[3/4] cursor-pointer image-hover-overlay bg-gray-100"
                onClick={() => openLightbox(GREGORIO_IMG, 'Gregorio Burciaga - Founder/Executive VP')}
              >
                <img 
                  src={GREGORIO_IMG} 
                  alt="Gregorio Burciaga - Founder/Executive VP"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h4 className="text-2xl mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Gregorio Burciaga</h4>
                <p className="text-[#53131e] font-semibold text-sm mb-3">Founder / Executive VP</p>
                <p className="text-gray-600 text-[15px] leading-relaxed">Founding Magna Specialty Contractors with 30+ years of industry expertise, driving technical innovation and client relationships.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 md:py-24 bg-[#0a0a0a] text-white" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center mb-16" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Contact Us</h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Details - Reordered: Phone, Email, Address, Service Area */}
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-[#53131e] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <h4 className="text-lg font-semibold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Phone</h4>
                  <a href="tel:6823208668" className="text-gray-400 hover:text-[#53131e] transition-colors" data-testid="contact-phone-link">
                    (682) 320-8668
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-[#53131e] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <h4 className="text-lg font-semibold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Email</h4>
                  <a href="mailto:magnabids@magnaspecialtycontractors.net" className="text-gray-400 hover:text-[#53131e] transition-colors break-all" data-testid="contact-email-link">
                    magnabids@magnaspecialtycontractors.net
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-[#53131e] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <h4 className="text-lg font-semibold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Address</h4>
                  <p className="text-gray-400">781 Station Dr #101<br />Arlington, TX 76015</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Building2 className="w-6 h-6 text-[#53131e] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <h4 className="text-lg font-semibold mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Service Area</h4>
                  <p className="text-gray-400">North Texas — DFW Metroplex</p>
                </div>
              </div>
            </div>

            {/* Google Maps - Right Side */}
            <div className="bg-white rounded-sm overflow-hidden" data-testid="google-maps-container">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d857.0687692747467!2d-97.1182663!3d32.7008681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e7d95a4421b85%3A0xff7e464aa04d0422!2sMagna%20Specialty%20Contractors!5e0!3m2!1sen!2sus!4v1712520000000!5m2!1sen!2sus"
                width="100%" 
                height="400" 
                style={{ border: 0 }}
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Magna Specialty Contractors Location"
                data-testid="google-maps-embed"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0a0a0a] text-white py-12 border-t border-[#262626]" data-testid="footer">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src={LOGO_URL} 
                  alt="Magna Specialty Contractors Corp. Logo"
                  className="h-10 w-auto"
                />
                <span className="font-semibold text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Magna Specialty Contractors</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                North Texas premier mechanical insulation and heat trace specialists. Women and minority-owned certified business with 30+ years of excellence.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Quick Links</h4>
              <div className="space-y-2">
                {navLinks.map((link) => (
                  <button 
                    key={link.id}
                    onClick={() => scrollToSection(link.id)} 
                    className="block text-gray-400 hover:text-[#53131e] transition-colors text-sm"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Contact & Certifications */}
            <div>
              <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Contact Info</h4>
              <div className="space-y-3 mb-6">
                <a href="tel:6823208668" className="flex items-center text-gray-400 hover:text-[#53131e] transition-colors text-sm" data-testid="footer-phone">
                  <Phone className="w-4 h-4 mr-2" strokeWidth={1.5} />
                  (682) 320-8668
                </a>
                <a href="mailto:magnabids@magnaspecialtycontractors.net" className="flex items-center text-gray-400 hover:text-[#53131e] transition-colors text-sm break-all" data-testid="footer-email">
                  <Mail className="w-4 h-4 mr-2 flex-shrink-0" strokeWidth={1.5} />
                  magnabids@magnaspecialtycontractors.net
                </a>
                <p className="flex items-center text-gray-400 text-sm">
                  <MapPin className="w-4 h-4 mr-2 flex-shrink-0" strokeWidth={1.5} />
                  781 Station Dr #101, Arlington, TX 76015
                </p>
              </div>
              <div className="space-y-1">
                <p className="text-xs text-gray-500 uppercase tracking-wider">Certifications</p>
                <p className="text-sm text-gray-400">SBE · MBE · WBE · MWBE · NCTRCA · WBENC</p>
              </div>
            </div>
          </div>

          <div className="border-t border-[#262626] pt-8 text-center text-gray-500 text-sm">
            <p>&copy; {new Date().getFullYear()} Magna Specialty Contractors Corp. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Lightbox */}
      <Lightbox 
        isOpen={lightbox.isOpen}
        imageSrc={lightbox.imageSrc}
        imageAlt={lightbox.imageAlt}
        onClose={closeLightbox}
      />
    </div>
  );
};

export default HomePage;
